import { Injectable } from '@angular/core'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { Observable, throwError, of } from 'rxjs'
import { environment } from 'environments/environment'
import { File } from 'app/models/file'
import { UPTOPResult } from 'app/models/uptop'
import { map, catchError, switchMap } from 'rxjs/operators'
import { SharepointService } from 'app/services/sharepoint.service'
import { CompetitionService } from 'app/services/competition.service'
import { IAssetsService } from 'app/models/asset.service.interface'

@Injectable({
  providedIn: 'root'
})
export class FilesService implements IAssetsService {

  private apiUrl = environment.api.url + environment.api.content.url

  constructor(private http: HttpClient,
              private sharepointService: SharepointService,
              private competitionService: CompetitionService) {
  }

  get(id): Observable<File> {
    const competitionId = this.competitionService.getCompetitionId()
    if (!competitionId) {
      return throwError('Competition not loaded')
    }
    
    let params = new HttpParams()
    params = params.append('competition', competitionId)
    params = params.append('id', id)
    params = params.append('op', environment.api.content.type.assets.op)
    params = params.append('source', environment.api.content.type.assets.file)

    return this.http
      .get<File>(this.apiUrl, {params})
      .pipe(
        map(res => <File>res),
        catchError(err => throwError(err || 'ServerErr'))
      )
  }

  create(file: File): Observable<File> {
    file.updateDate = new Date().getTime()
    return this.http
      .post<any>(this.apiUrl, file)
      .pipe(
        map(res => res.Item),
        catchError(err => throwError(err || 'ServerErr'))
      )
  }

  getAll(
    lastEvaluatedKey?: any,
    index?: string
  ): Observable<UPTOPResult> {
    const competitionId = this.competitionService.getCompetitionId()
    if (!competitionId) {
      return of({Items: [], Count: 0, ScannedCount: 0} as UPTOPResult)
    }
    
    let params = new HttpParams()
    params = params.append('op', environment.api.content.type.assets.op)
    params = params.append('competition', competitionId)
    params = params.append('source', environment.api.content.type.assets.filesContentTypes)

    params = (index) ? params.append('filter', index) : params
    let headers = new HttpHeaders()
    if (lastEvaluatedKey) {
      headers = headers.append('lastevaluatedkey', btoa(JSON.stringify(lastEvaluatedKey)))
    }

    return this.http
      .get<UPTOPResult>(this.apiUrl, {headers, params})
      .pipe(
        map((res) => {
          console.log(res)
          return res as UPTOPResult
        }),
        catchError((err) => throwError(err || 'ServerErr'))
      )
  }

  update(file: File): Observable<File> {
    file.updateDate = new Date().getTime()
    return this.http
      .put<File>(this.apiUrl, file)
      .pipe(
        map(res => <File>res),
        catchError(err => throwError(err || 'ServerErr'))
      )
  }

  delete(id: string): Observable<File> {
    let params = new HttpParams()
    params = params.append('op', environment.api.content.type.assets.op)
    params = params.append('element', id)

    return this.http
      .delete<File>(this.apiUrl, {params})
      .pipe(
        map(res => <File>res),
        catchError(err => throwError(err || 'ServerErr'))
      )
  }

  download(id: string): Observable<any> {
    return this.sharepointService.downloadSharepoint(id).pipe(map(res => res))
  }
}
